(function () {
  'use strict';

var dy_debouncer = function () {
  var self = this;

  self.init();

};

dy_debouncer.prototype.config = {
  default_time: 100
};

dy_debouncer.prototype.init = function() {
  // var self = this;
};



dy_debouncer.prototype.debounce = function (func, threshold, execAsap) {
  var self = this;

  var timeout;

  var default_time = self.config.default_time;

  return function debounced () {
      var obj = this, args = arguments;
      function delayed () {
          if (!execAsap) {
            func.apply(obj, args);
          }
          timeout = null;
      }

      if (timeout) {
          clearTimeout(timeout);
      }
      else if (execAsap) {
          func.apply(obj, args);
      }

      timeout = setTimeout(delayed, threshold || default_time);
  };
};


/*----------------------------------------------------------------------------*/
// Component Public
/*----------------------------------------------------------------------------*/

  window.dy_debouncer = new dy_debouncer();

}());
